import './Ads.css';
import strings from '../../config/App.json';

import AdSlot from './components/AdSlot';

export const Business_sponsor_Ad = () => {
  return (
    <div className="business-sponsor-ads">
      <div className="ad" id="bottom-ad">
        <a
          href={strings.ContactPage}
          className='Business_ad-image'
        >
          <img
            src="/images/Ads/businessAd.png"
            alt="Ad 1"
            className="Business_ad-image"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};

export const Business_bottomAd = () => {
  return (
    <a className='business_bottomAd'
      href={strings.ContactPage}>
      <div className='business_bottomad-flex'>
        <span className='business_bottomAd-text'>
          <img
            src="/images/Ads/announcement.png"
            alt="Ad 1"
            className="business_bottomAd-image"
            loading="lazy"
          /> Reach the right audience.
        </span>
        <span className='business_bottomAd-text'>
          Promote your business with us
        </span>
      </div>
    </a>
  )
};

const BusinessSideAds = () => {
  return (
    <AdSlot
      slotKey="business_side_ad"
      containerClass="business_side_ads"
      className="business_side_ad_image"
      id="business_side_ad"
    />
  );
};

export { BusinessSideAds };
